let isFancyboxActive = false

export const setFancyboxActive = (value) => {
  isFancyboxActive = value
}

export const shouldIgnoreModalClose = (reason) => {
  return reason === 'escapeKeyDown' && isFancyboxActive
}
